import React, { useEffect, useState } from "react";
import TeacherWalletTable from "./table";
import { FaLock, FaWallet } from "react-icons/fa";
import TableSkeleton from "../../../components/skeleton/table";
import CardComponent from "../../../components/card";
import CardSkeleton from "../../../components/skeleton/card";
import PaginationComponent from "../../../components/pagination";
import formatDataForFilters from "./format-data";
import TransferAmountModal from "./transfer-modal";
import api from "../../../services/api";

const TeacherWalletSummary = ({ id, month }) => {
  const [balanceDetails, setBalanceDetails] = useState();
  const [loading, setLoading] = useState({});
  const [activeTab, setActiveTab] = useState("inbound");

  const [selectedOfferSlotIds, setSelectedOfferSlotIds] = useState([]);
  const [totalTransferAmount, setTotalTransferAmount] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [pageNos, setPageNos] = useState({
    inbound: 1,
    outbound: 1,
    merge: 1,
  });

  const [totalPages, setTotalPages] = useState({
    inbound: 1,
    outbound: 1,
    merge: 1,
  });

  const [tabData, setTabData] = useState({
    inbound: {},
    outbound: {},
    merge: {},
  });

  const setApiLoading = (key, value) => {
    setLoading((prev) => ({ ...prev, [key]: value }));
  };

  const fetchTransactions = async (type, page) => {
    const key = `${type}_${page}`;
    try {
      setApiLoading(key, true);
      const { data } = await api.get(
        `/teachers/${id}/transactions?type=${
          type === "merge" ? "inoutbound" : type
        }&page=${page}&month=${month}`
      );
      const result = data?.data || [];
      const formatedData = formatDataForFilters(type, result);
      setTabData((prev) => ({
        ...prev,
        [type]: {
          ...prev[type],
          [page]: formatedData,
        },
      }));

      setTotalPages((prev) => ({
        ...prev,
        [type]: data?.totalPages || 1,
      }));
    } catch (error) {
      console.error(error);
    } finally {
      setApiLoading(key, false);
    }
  };

  const fetchTeacherBalance = async () => {
    let key = "balance";
    try {
      setApiLoading(key, true);
      const res = await api.get(
        `/teachers/${id}/balance`
      );
      setBalanceDetails(res?.data?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setApiLoading(key, false);
    }
  };

  useEffect(() => {
    // reset tabData and pageNos when id or month changes
    setTabData({
      inbound: {},
      outbound: {},
      merge: {},
    });
    setPageNos({
      inbound: 1,
      outbound: 1,
      merge: 1,
    });
    setTotalPages({
      inbound: 1,
      outbound: 1,
      merge: 1,
    });
    fetchTeacherBalance();
  }, [id, month]);

  useEffect(() => {
    const currentPage = pageNos[activeTab];
    fetchTransactions(activeTab, currentPage);
  }, [pageNos, activeTab, id, month]);

  const handlePageChange = (page) => {
    setPageNos((prev) => ({
      ...prev,
      [activeTab]: page,
    }));
  };

  const grandTotal = Object.values(tabData?.merge || {})
    .flat()
    .reduce((acc, curr) => {
      return Math.round(acc + parseFloat(curr?.amount || 0));
    }, 0);

  const stats = [
    {
      icon: <FaWallet size={30} color="#52c41a" />,
      number: `${balanceDetails?.balance ?? 0} PKR`,
      label: "Balance",
    },
    {
      icon: <FaLock size={30} color="#722ed1" />,
      number: `${grandTotal} PKR`,
      label: "Transactions",
    },
  ];

  const renderContent = () => {
    const currentPage = pageNos[activeTab];
    const isLoading = loading[`${activeTab}_${currentPage}`];
    const data = tabData[activeTab]?.[currentPage] || [];

    if (isLoading) return <TableSkeleton columns={5} rows={4} />;
    return (
      <div style={{ height: "400px", width: "100%", overflow: "hidden" }}>
        <TeacherWalletTable
          transactionsData={data}
          tab={activeTab}
          selectedOfferSlotIds={selectedOfferSlotIds}
          setSelectedOfferSlotIds={setSelectedOfferSlotIds}
          setTotalTransferAmount={setTotalTransferAmount}
        />
      </div>
    );
  };

  return (
    <div className="overflow-hidden">
      {balanceDetails && Object.keys(balanceDetails).length > 0 ? (
        <CardComponent data={stats} />
      ) : (
        <CardSkeleton loading={loading["balance"]} boxes={3} />
      )}
      <div className="d-flex justify-content-end items-end mt-4">
        {selectedOfferSlotIds.length > 0 && (
          <button
            type="button"
            className="btn btn-dark"
            onClick={() => setIsModalOpen(true)}
          >
            Pay
          </button>
        )}
        {isModalOpen && (
          <TransferAmountModal
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            selectedOfferSlotIds={selectedOfferSlotIds}
            transferAmount={totalTransferAmount}
            teacherId={id}
          />
        )}
      </div>

      <div className="mt-2 col-sm-12 col-md-12 col-lg-12 mx-auto shadow border rounded py-2 overflow-hidden">
        <ul className="nav nav-tabs mb-3">
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "inbound" ? "active" : ""}`}
              onClick={() => setActiveTab("inbound")}
            >
              Income
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "outbound" ? "active" : ""}`}
              onClick={() => setActiveTab("outbound")}
            >
              Received
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "merge" ? "active" : ""}`}
              onClick={() => setActiveTab("merge")}
            >
              Transaction's History
            </button>
          </li>
        </ul>

        <div className="tab-content">
          <div className="table-responsive">{renderContent()}</div>
        </div>

        <div className="text-end">
          <PaginationComponent
            currentPage={pageNos[activeTab]}
            totalPages={totalPages[activeTab]}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};

export default TeacherWalletSummary;
